import React, { Fragment } from 'react';
import { observer } from 'mobx-react';
import { http } from '../../services/HttpInterceptor';
import { RouteComponentProps, Link } from "react-router-dom";
import { toast } from 'react-toastify';
import { observable } from 'mobx';
import { formatRelative } from 'date-fns';
import { es } from 'date-fns/locale';

interface ViewHistoryProps extends RouteComponentProps {
    changeToggle(action?: boolean): void
}

@observer export default class ViewHistory extends React.Component<ViewHistoryProps> {

    @observable private history: any = [];
    @observable private id: any = "";
    @observable private isLoaded: boolean = false;

    componentDidMount() {
        this.props.changeToggle(true);
        this.init();
    }

    init = () => {
        const match = this.props.match;
        const id = (match as any).params.id;
        this.id = id;
        http.get(`/api/contract/log/${id}`).then((response) => {
            this.history = response.data.response.data;
            this.isLoaded = true;
        })
            .catch(() => {
                toast.error("Error cargando Recibo");
            });
    }

    groupByTimestamp = () => {
        const grouped: { [key: string]: any[] } = {};
        this.history.forEach((record: any) => {
            if (!grouped[record.change_timestamp]) {
                grouped[record.change_timestamp] = [];
            }
            grouped[record.change_timestamp].push(record);
        });
        return grouped;
    }

    render() {
        if (!this.isLoaded) {
            return null;
        }

        const groupedHistory = this.groupByTimestamp();

        return (
            <Fragment>
                <div className="row">
                    <div className="col-sm-12">
                        <div className="card">
                            <div className="card-header card-header-rose card-header-text">
                                <div className="card-text">
                                    <h4 className="card-title">Historial del Contrato: #{this.id}</h4>
                                </div>
                            </div>
                            <div className="card-body ">
                                <div className="row">
                                    <div className="col-sm-10"></div>
                                    <div className="col-sm-2">
                                        <Link to={`../../contratos`}>
                                            <button className="btn btn-danger btn-sm  pull-right">
                                                <i className="material-icons">highlight_off</i>
                                                <div className="ripple-container"></div>
                                            </button>
                                        </Link>
                                    </div>
                                </div>
                                {Object.keys(groupedHistory).map((timestamp, index) => {
                                    const records = groupedHistory[timestamp];
                                    return (
                                        <div className="row" key={index}>
                                            <div className="col-sm-12">
                                                <div className="card">
                                                    <div className="card-header card-header-rose">
                                                    <h4 className="card-title">{`Edición de ${formatRelative(new Date(timestamp), new Date(), { locale: es })}`}
</h4>
                                                    </div>
                                                    <div className="card-body">
                                                        {records.map((record, idx) => (
                                                            <div key={idx}>
                                                                <p><strong>Nombre de columna:</strong> {record.column_name}</p>
                                                                <p><strong>Valor original:</strong> {record.old_value}</p>
                                                                <p><strong>Valor nuevo:</strong> {record.new_value}</p>
                                                                <hr />
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}